module.exports = __webpack_public_path__ + "97d8481270220958196efbbe07a9f0b7.pdf";